/** In-memory Builder reply. A remount can still show the reply the writer was charged for. */

const sessions = new Map();
const listeners = new Set();

export function builderSessionKey(storyId) {
  return storyId || 'none';
}

export function readBuilderSession(storyId) {
  return sessions.get(builderSessionKey(storyId)) || null;
}

export function writeBuilderSession(storyId, patch) {
  const key = builderSessionKey(storyId);
  const prev = sessions.get(key) || { storyId: key, writerClosed: false };
  const next = {
    ...prev,
    ...patch,
    storyId: key,
    revision: (prev.revision || 0) + 1,
  };
  sessions.set(key, next);
  listeners.forEach((fn) => fn(next));
  return next;
}

export function clearBuilderSession(storyId) {
  const key = builderSessionKey(storyId);
  const prev = sessions.get(key);
  if (!prev) return;
  sessions.delete(key);
  listeners.forEach((fn) => fn({ ...prev, cleared: true, storyId: key }));
}

export function resetBuilderSessions() {
  sessions.clear();
}

export function subscribeBuilderSession(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** A reply is in flight, or a finished reply is waiting, and the writer did not leave. */
export function builderSessionIsLive(session) {
  if (!session || session.writerClosed || session.cleared) return false;
  if (session.pending) return true;
  if ((session.parts || []).some((row) => String(row?.name || '').trim())) return true;
  return (session.messages || []).length > 1;
}
